export async function getUserFromMidwayCredentials(credentials) {
  try {
    if (!credentials) {
      return "defaultUser";
    }
    if (credentials.needsRefresh()) {
      await new Promise((resolve, reject) => {
        credentials.refresh((err) => err ? reject(err) : resolve());
      });
    }
    const token = credentials.params?.Logins?.["midway-auth.amazon.com"];
    if (!token) {
      return "defaultUser";
    }
    const payload = JSON.parse(atob(token.split(".")[1]));
    return payload.sub || "defaultUser";
  } catch (error) {
    console.warn("Error getting user from credentials:", error);
    return "defaultUser";
  }
}
